import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import VinInput from '../../Car/NewCar/VinInput';
import findByVin from '../../../api/cars/findByVin';
import SelectedCarFields from './SelectedCarFields';
import { FULL_VIN_LENGTH, colorName, isSameVin, vinSearchQuery } from '../../Car/NewCar/vinSearch';
import ConsignmentCreate from '../../Car/NewCar/Consignment/ConsignmentCreate';
import { needsNewCar } from './needsNewCar';
import formatNumber from '../../../utils/formatNumber';
import formStyles from '../../../components/Form/form.module.css';
import { textStyles } from '../../../constants/textStyles';

const card = {
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '14px 16px',
  border: '1px solid #E3E3E3',
  borderRadius: 10,
  background: '#fff',
};
const link = {
  border: 'none',
  background: 'none',
  padding: 0,
  color: 'var(--brand-primary)',
  textDecoration: 'underline',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

const toVin = (value) =>
  String(value || '')
    .replace(/[^0-9a-z]/gi, '')
    .toUpperCase();

/**
 * ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½Ð° Ð¿ÐµÑÐ²Ð¾Ð¼ ÑÐ°Ð³Ðµ ÑÐ´ÐµÐ»ÐºÐ¸ Ñ ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ°: Ð²Ð¼ÐµÑÑÐ¾ Ð¾ÐºÐ½Ð° Ñ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¾Ð¼ â Ð¿Ð¾Ð»Ðµ VIN.
 *  Â· Ð²Ð²Ð¾Ð´Ð¸Ð¼ Ð½Ð¾Ð¼ÐµÑ â Ð¿Ð¾Ð´ Ð¿Ð¾Ð»ÐµÐ¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ÑÐ¾Ð¶Ð¸Ñ Ð¼Ð°ÑÐ¸Ð½ Ð¸Ð· Ð±Ð°Ð·Ñ, Â«ÐÑÐ±ÑÐ°ÑÑÂ» ÑÑÐ°Ð²Ð¸Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ´ÐµÐ»ÐºÑ;
 *  Â· ÑÐ°ÐºÐ¾Ð³Ð¾ VIN Ð½ÐµÑ â ÑÑÑ Ð¶Ðµ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ ÑÐ¾ÑÐ¼Ð° Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ; ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ Ð²Ð¼ÐµÑÑÐµ ÑÐ¾ ÑÐ´ÐµÐ»ÐºÐ¾Ð¹
 *    (ÑÐºÑÐ°Ð½ ÑÐ´ÐµÐ»ÐºÐ¸ Ð·Ð¾Ð²ÑÑ ref.submitNewCar()).
 */
const GreyDealCar = forwardRef(({ cars, onPick, onRemove, error }, ref) => {
  const [vin, setVin] = useState('');
  const [search, setSearch] = useState(null);
  const newCarRef = useRef(null);

  const selected = cars?.[0];
  const showNewForm = !selected && needsNewCar(vin, search);

  // Â«ÐÑÐ±ÑÐ°ÑÑÂ» ÑÑÐ°Ð±Ð°ÑÑÐ²Ð°ÐµÑ ÑÑÐ°Ð·Ñ: ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð¼Ð°ÑÐ¸Ð½Ñ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ Ð¸Ð· Ð´Ð°Ð½Ð½ÑÑ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ¸, Ð¿Ð¾ÐºÐ° Ð¿Ð¾Ð»Ð½Ð°Ñ ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð³ÑÑÐ·Ð¸ÑÑÑ.
  const [pending, setPending] = useState(null);
  // ÐÐ°Ð½Ð½ÑÐµ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐ²ÑÑÐ½ÑÑÑ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾Ð±ÑÑÐ½Ð¾ ÑÐ²Ð°ÑÐ°ÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸, Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ ÑÑÑÐµÐ»ÐºÐ¾Ð¹.
  const [expanded, setExpanded] = useState(false);
  const shown = selected || pending;
  const pickFound = async (found) => {
    setPending(found);
    try {
      await onPick(found);
    } finally {
      setPending(null);
    }
  };

  // ÐÐ¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾; null â ÑÐ¾ÑÐ¼Ñ Ð½ÐµÑ Ð¸Ð»Ð¸ Ð² Ð½ÐµÐ¹ ÑÑÐ¾-ÑÐ¾ Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾ / Ð½Ðµ ÑÐ¾ÑÑÐ°Ð½Ð¸Ð»Ð¾ÑÑ.
  useImperativeHandle(ref, () => ({
    hasNewCar: () => showNewForm,
    // ÐÐ²ÐµÐ»Ð¸ Ð¿Ð¾Ð»Ð½ÑÐ¹ VIN, Ð½Ð¾ Ð½Ðµ Ð½Ð°Ð¶Ð°Ð»Ð¸ Â«ÐÑÐ±ÑÐ°ÑÑÂ», Ð¸ Ð¸Ð´ÑÑ Ð´Ð°Ð»ÑÑÐµ: ÐµÑÐ»Ð¸ ÑÐ°ÐºÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° ÐµÑÑÑ, Ð±ÐµÑÑÐ¼ ÐµÑ ÑÐ°Ð¼Ð¸.
    // Ð¡Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ Ð±ÑÐº Ð½Ð°Ð¿ÑÑÐ¼ÑÑ â Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð¼Ð¾Ð³Ð»Ð° ÐµÑÑ Ð½Ðµ ÑÑÐ¿ÐµÑÑ Ð¾ÑÐ²ÐµÑÐ¸ÑÑ.
    findExisting: async () => {
      if (selected || String(vin).length !== FULL_VIN_LENGTH) return null;
      const res = await findByVin(vinSearchQuery(vin)).catch(() => null);
      const list = Array.isArray(res?.data) ? res.data : [];
      return list.find((car) => isSameVin(car, vin)) || null;
    },
    submitNewCar: () => (newCarRef.current ? newCarRef.current.submit() : Promise.resolve(null)),
  }));

  return (
    <>
      <div className={formStyles.wrapper} style={{ marginTop: 0 }}>
        <p style={textStyles.formTitle}>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ</p>

        {shown ? (
          <div style={{ ...card, marginTop: 16, opacity: selected ? 1 : 0.65 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 600 }}>
                {[shown.mark, shown.model].filter(Boolean).join(' ')}
                {shown.issueYear ? `, ${shown.issueYear}` : ''}
              </div>
              <div style={{ fontSize: 13, color: '#8B8B8B', marginTop: 4 }}>
                {[shown.vin, colorName(shown.color), shown.price ? `${formatNumber(shown.price)} â¸` : '']
                  .filter(Boolean)
                  .join(' Â· ')}
              </div>
            </div>
            {selected ? (
              <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                <button
                  type="button"
                  style={{ ...link, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}
                  aria-expanded={expanded}
                  onClick={() => setExpanded((value) => !value)}
                >
                  {expanded ? 'Ð¡Ð²ÐµÑÐ½ÑÑÑ' : 'ÐÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'}
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    aria-hidden="true"
                    style={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}
                  >
                    <path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </button>
                <button
                  type="button"
                  style={link}
                  onClick={() => {
                    setVin('');
                    setSearch(null);
                    setExpanded(false);
                    onRemove(selected);
                  }}
                >
                  ÐÐ°Ð¼ÐµÐ½Ð¸ÑÑ
                </button>
              </div>
            ) : (
              <span style={{ fontSize: 13, color: '#8B8B8B', whiteSpace: 'nowrap' }}>ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼â¦</span>
            )}
          </div>
        ) : (
          <div style={{ marginTop: 16, maxWidth: 520 }}>
            <VinInput
              label="VIN Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ"
              placeholder="ÐÐ²ÐµÐ´Ð¸ÑÐµ VIN â Ð½Ð°Ð¹Ð´ÑÐ¼ Ð² Ð±Ð°Ð·Ðµ Ð¸Ð»Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð¸Ð¼ Ð½Ð¾Ð²ÑÐ¹"
              name="dealVin"
              maxLength={17}
                required
              value={vin}
              transform={toVin}
              onChange={(next) => setVin(typeof next === 'string' ? next : toVin(next?.target?.value))}
              onSearch={setSearch}
              onPickCar={pickFound}
              error={Boolean(error)}
            />
            {error && <p style={{ margin: '6px 0 0', fontSize: 12, color: '#EB5757' }}>{error}</p>}
          </div>
        )}

        {showNewForm && (
          <p style={{ margin: '16px 0 0', fontSize: 14, color: '#6A6A6A' }}>
            Ð¢Ð°ÐºÐ¾Ð³Ð¾ VIN Ð² Ð±Ð°Ð·Ðµ Ð½ÐµÑ. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð½Ð¸Ð¶Ðµ â Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑÑ Ð²Ð¼ÐµÑÑÐµ ÑÐ¾ ÑÐ´ÐµÐ»ÐºÐ¾Ð¹.
          </p>
        )}
      </div>

      {selected && expanded && <SelectedCarFields car={selected} />}

      {showNewForm && <ConsignmentCreate ref={newCarRef} embedded vin={vin} />}
    </>
  );
});

export default GreyDealCar;
